import { queryModule, queryModuleWithData } from 'iguazu-holocron';
import { queryLanguagePack } from '@americanexpress/one-app-ducks';
import { queryProcedureResult } from 'iguazu-rpc';
import { getSelectedProduct, getProducts } from '@americanexpress/product-ducks';
import { defer } from 'iguazu';
import { ENABLE_ONEDATA_IB } from './enableOnedata';

function getHipedAccountToken(state) {
  const selectedProduct = getSelectedProduct(state);
  const productsList = getProducts(state);
  return selectedProduct && productsList && productsList[selectedProduct]
    && productsList[selectedProduct].hipedAccountToken
    ? productsList[selectedProduct].hipedAccountToken
    : selectedProduct;
}

export function loadDataAsProps({ store: { dispatch, getState }, ownProps }) {
  const props = {
    langPack: () => dispatch(queryLanguagePack('axp-maps-root'), { fallbackLocale: 'en-US' }),
    AccountSwitcher: () => dispatch(queryModuleWithData('axp-account-switcher')),
    Footer: () => dispatch(queryModule('axp-footer')),
  };
  if (!(ownProps && ownProps.location && ownProps.location.pathname && ownProps.location.pathname.includes('/maps/offers'))) {
    props.programDetailsIguazu = defer(() => dispatch(queryProcedureResult({
      procedureName: 'loadProgramDetails',
      args: {
        locale: ownProps.locale.toLowerCase(),
      },
    })));
    props.interstitialIguazu = defer(() => dispatch(queryProcedureResult({
      procedureName: 'loadInterstitial',
      args: {
        locale: ownProps.locale,
      },
    })));
    props.notificationIguazu = defer(() => dispatch(queryProcedureResult({
      procedureName: 'loadNotification',
      args: {
        locale: ownProps.locale,
      },
    })));
    /* istanbul ignore next */
    if (ENABLE_ONEDATA_IB) {
      /* istanbul ignore next */
      props.ibDataOneData = defer(() => dispatch(queryProcedureResult({
        procedureName: 'ReadMerchantMapIndustryBonusCategories',
        args: {
          query: ownProps.location.query,
          pathname: ownProps.location.pathname,
          accountKey: getHipedAccountToken(getState()),
        },
      })));
    } else {
      /* istanbul ignore next */
      props.ibDataIguazu = defer(() => dispatch(queryProcedureResult({
        procedureName: 'loadIndustryBonus',
        args: {
          query: ownProps.location.query,
          pathname: ownProps.location.pathname,
          accountKey: getSelectedProduct(getState()),
        },
      })));
    }
    props.filterLabelIguazu = defer(() => dispatch(queryProcedureResult({
      procedureName: 'loadFilterlabels',
      args: {
        locale: ownProps.locale,
      },
    })));
    /* istanbul ignore next */
    if (getSelectedProduct(getState())) {
      /* istanbul ignore next */
      props.merchantsOneData = defer(() => dispatch(queryProcedureResult({
        procedureName: 'ReadMerchantMapRecommendation',
        args: {
          query: ownProps.location.query,
          pathname: ownProps.location.pathname,
          accountKey: getHipedAccountToken(getState()) || '',
          search: ownProps.location.search,
        },
      })));
    } else {
      props.merchantsOneData = defer(() => dispatch(queryProcedureResult({
        procedureName: 'ReadMerchantPublicMapRecommendation',
        args: {
          query: ownProps.location.query,
          pathname: ownProps.location.pathname,
          search: ownProps.location.search,
        },
      })));
    }
  }
  return props;
}
loadDataAsProps.ssr = true;
